import Helper from "../../Helper";
import { ApiKey } from "../../models/ApiKey";
import { plotFetch } from "../Helper/ApiRequest";

export function create(project: any): Promise<void | ApiKey> {
    const url = `${Helper.baseUrlWithPort()}/projects/${project.unique_token}/api_keys`;

    return plotFetch(url, { method: "POST" })
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Failed to create API key");
            }
        })
        .then((response) => {
            return ApiKey.fromApiObject(response.api_key, project.timezone || "UTC");
        })
        .catch((_error) => {});
}

export function changeState(project: any, apiKey: ApiKey): Promise<boolean> {
    const url = `${Helper.baseUrlWithPort()}/projects/${project.unique_token}/api_keys/${apiKey.id}`;

    return plotFetch(url, {
        method: "PUT",
        body: JSON.stringify({ state: apiKey.state }),
        headers: { "Content-Type": "application/json" },
    })
        .then((response) => {
            if (response.ok) {
                return true;
            }
            return false;
        })
        .catch((_error) => {
            return false;
        });
}

export function list(project: any): Promise<ApiKey[]> {
    const url = `${Helper.baseUrlWithPort()}/projects/${project.unique_token}/api_keys`;

    return plotFetch(url, { method: "GET" })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((apiKey: any) => ApiKey.fromApiObject(apiKey, project.timezone || "UTC"));
        })
        .catch((_error) => {
            return [];
        });
}
